var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZksyncLogo = function SvgZksyncLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "zksync-logo_svg__Layer_1",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    viewBox: "0 0 400 400",
    x: 0,
    y: 0
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".zksync-logo_svg__st1{fill-rule:evenodd;clip-rule:evenodd}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    },
    d: "M0 0h400v400H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "zksync-logo_svg__st1",
    d: "m316 199-66.7-66.4v48.6l-66.2 48.7h66.2v35.5L316 199zM81 199l66.7 66.4v-48.3l66.2-49.1h-66.2v-35.5L81 199z"
  })));
};
export default SvgZksyncLogo;